import userQueries from '@apis/queries/userQueries';
import UserApi from '@apis/user/UserApi';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

function useToggleMarketingAgreement() {
    const { t } = useTranslation('accountSetting');
    const queryClient = useQueryClient();
    const toast = useToast();
    const { mutate } = useMutation({
        mutationFn: UserApi.toggleMarketingAgreement,
        onSuccess() {
            queryClient.invalidateQueries({ queryKey: userQueries.detail._def });
        },
        onError(e: AxiosError<ErrorResponse>) {
            toast.error(e?.response?.data.message || t('toast.unknownError'));
        },
    });
    return () => mutate();
}

export default useToggleMarketingAgreement;
